import { useContext, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { AppContext } from '../context/AppContext'
import fetchData from '../utils/fetchData'
import getCookie from '../utils/getCookie'

const DeleteStoreOrder = ({
  isModal,
  setModal,
  id,
  setId,
  getStoreOrders,
  onDeleted,
}) => {
  const { setAlert } = useContext(AppContext)
  const [isSubmitting, setSubmitting] = useState(false)

  const hideModal = () => {
    setModal(false)
    setId?.()
  }

  const handleDelete = async (e) => {
    e.preventDefault()
    if (!id) return
    setSubmitting(true)
    try {
      await fetchData.delete(`/storeOrder/${id}`, {
        headers: { Authorization: `Bearer ${getCookie('eyevaryToken')}` },
      })
      getStoreOrders?.()
      setAlert({
        show: true,
        variant: 'success',
        message: 'Store order successfully deleted.',
        icon: 'mdi mdi-check',
        duration: 5,
      })
      hideModal()
      onDeleted?.()
    } catch (error) {
      console.log({ ...error }, error)
      setAlert({
        show: true,
        variant: 'danger',
        message:
          error?.response?.data?.message ||
          'Something went wrong. Please try again.',
        icon: 'mdi mdi-close',
        duration: 5,
      })
    }
    setSubmitting(false)
  }

  return (
    <Modal show={isModal} size='sm' centered onHide={hideModal}>
      <Modal.Header closeButton>
        <Modal.Title>Are You Sure</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Once you click on delete you will never recover this order again.
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' size='sm' onClick={hideModal}>
          Cancel
        </Button>
        <Button
          variant='danger'
          size='sm'
          onClick={handleDelete}
          disabled={isSubmitting}>
          Delete
          {isSubmitting && (
            <Spinner animation='border' size='sm' className='ms-2' />
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteStoreOrder
